import React from 'react';
import PropTypes from 'prop-types';

/**
 * @param (String)  color  btn-primary and btn-secondary are styled in scss, add more options there if you need them
 * @param (String)  width  pass in px or %
 */

const ButtonReadings = ({ iconUrl, text, color, width, className, onClick, ...rest }) => {
  let styles = { width: `${width || 'auto'}` };
  if (iconUrl) styles = { ...styles, backgroundImage: `url("${iconUrl}")` };

  return (
    <button
      className={`btn-${color} ${iconUrl ? 'btn-ico' : 'btn-txt'} ${className || ''}`}
      style={styles}
      onClick={onClick}
      {...rest}
    >
      {text}
    </button>
  );
};

ButtonReadings.propTypes = {
  color: PropTypes.oneOf(['primary', 'secondary']),
  width: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.string,
  iconUrl: PropTypes.string,
  onClick: PropTypes.func
};

export const ButtonSearch = ({ iconUrl, text, className, onClick }) => {
  return (
    <button
      className={`btn-search ${className || ''}`}
      style={{ backgroundImage: `url("${iconUrl}")` }}
      onClick={onClick}
    >
      <span>{text}</span>
    </button>
  );
};

ButtonSearch.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  iconUrl: PropTypes.string,
  onClick: PropTypes.func
};

export default ButtonReadings;
